<template>
  <Container class="container--main">
    <h1 class="title">Nueva contraseña </h1>
    <div class="msg__successful" v-if="successful">
          ¡{{ successful }}!
    </div>
    <form action="form" class="form" @submit.prevent="NewPassword">
      <label class="form-label" for="password">Nueva Contraseña<span class="camp_required">*</span>:</label>
        <input
          v-model="password"
          class="form-input"
          type="password"
          id="password"
          required
          placeholder="Ingrese la nueva contraseña"
        >
        <ul>
          <li>La contraseña debe ser de longitud mayor o igual 8 caracteres.</li>
          <li>Debe contener al menos una mayúscula, una minúscula y un carácter especial (@#$!%*^?&)</li>
        </ul>
        <Button
          class="btn__submit"
          tag="button"
          type="submit"
          theme="primary"
          >
            Confirmar nueva contraseña
        </Button>

        <ul class="errores_msg" v-if="errorList">
          <li v-for="error in errorList" :key="error">{{ error.msg }}.</li>
        </ul>
          
    </form>

      
  </Container>
</template>

<script>
import axios from "axios";
import Button from "@/components/ui/atoms/Button.vue";
import Container from "@/components/ui/objects/Container";

export default {
  components: {
    Button,
    Container
  },
  data() {
    return {
      password: '',
      successful: null,
    };
  },
  methods: {
    NewPassword() {
      axios.post(`${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/recuperacion-contrasena`,
      {
        password: this.password,
      },
      {
        headers: {
          "Authorization": 'Bearer ' + this.$route.params.token,
        }
      })
      .then(response => {
        if(response.data.msg.includes('satisfactoriamente')) {
          this.successful = response.data.msg;
          this.errorList = false;
       
        }else{
          this.errorList = response.data.msg;
          this.successful = false;
        }
      })
      .catch(error => {
        this.errorList = error.response.data.errors;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.title {
  text-align: center;
  color: variables.$primary-color;
}
.form {
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  min-width: 350px;
  max-width: 100%;
  border-radius: 5px;
}
.form-label {
  margin-top: 2rem;
  color: variables.$primary-color;
  margin-bottom: 0.5rem;
  &:first-of-type {
    margin-top: 0rem;
  }
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid variables.$primary-color;
  color: rgb(95, 95, 95);
  &:focus {
    outline: 0;
    border: 2px solid variables.$primary-color;
  }
}

.errores_msg li{
  color: red;
}
.camp_required{
  color: rgb(180, 12, 12);
}

.btn__submit{
  margin-top: 2rem;
}

.msg__successful{
  text-align: center;
  border: 1px solid green;
  border-radius: .2rem;
  padding: 1rem 0;
  margin-bottom: 2rem;
  background: #9fdbc2;
  color: rgb(0, 65, 35);
  font-size: 1.2rem;
}
</style>